import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    backgroundColor: theme.palette.banner.alert,
    [theme.breakpoints.down('sm')]: {
      display: 'flex'
    }
  },
  namesRoot: {
    height: 16,
    overflow: 'auto'
  }
}))

export default useStyles
